(function () {
  document.addEventListener("click", (e) => {
    if (
      !e.target.closest(".js-event-actions-trigger") &&
      !e.target.closest(".c-ui-popover")
    ) {
      removeAll();
    } else if (
      e.target.closest(".js-event-actions-trigger").classList.contains("on")
    ) {
      e.target.classList.remove("on");
      e.target.classList.add("off");
    } else if ($(".js-event-actions-trigger.on").length) {
      removeAll();
    } else {
      e.target.classList.remove("off");
      e.target.classList.add("on");
    }
  });

  function removeAll() {
    $(".js-event-actions-trigger").removeClass("on");
  }
}.call(this));
